import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AiChatService {
  public chatVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}
